module.exports = __webpack_public_path__ + "static/media/specification.59c7438b.md";